import { z } from "zod";
/**
 * Platform rolleri ve izinleri (ADR 0024 §2). Kiracı izinlerinden AYRIDIR: platform personelinin yetkisi `users.platform_role`
 * sütunundan gelir ve yalnızca `/platform/*` uçlarında denetlenir. Rol → izin eşlemesi koddadır (sabit; saf, test edilir);
 * web menüsü de aynı eşlemeyi kullanır.
 */
export const PLATFORM_ROLES = ["SUPER_ADMIN", "SUPPORT", "FINANCE", "READ_ONLY"];
export const platformRoleSchema = z.enum(PLATFORM_ROLES);
export const PLATFORM_ROLE_LABELS = {
    SUPER_ADMIN: "Süper yönetici",
    SUPPORT: "Destek",
    FINANCE: "Finans",
    READ_ONLY: "Salt okunur",
};
export const PLATFORM_PERMISSIONS = {
    "platform.tenants.read": "Kiracıları, kullanım ve sağlık özetlerini görüntüleme",
    "platform.tenants.manage": "Kiracı oluşturma, askıya alma, salt okunur moda alma",
    "platform.catalog.read": "Planları, özellik yayınlarını, ajan yayınlarını, duyuruları ve ayarları görüntüleme",
    "platform.plans.manage": "Plan, fiyat ve kullanım kalemi tanımlama",
    "platform.billing.read": "Abonelik, platform faturası ve tahsilatı görüntüleme",
    "platform.billing.manage": "Abonelik değiştirme, fatura kesme, ödeme girme",
    "platform.features.manage": "Özellik bayrakları ve kademeli yayın",
    "platform.releases.manage": "Ajan yayınları, yayın yüzdesi ve güncelleme kanalları",
    "platform.support.access": "Destek erişimi isteme ve kiracı adına görüntüleme",
    "platform.health.read": "Sistem sağlığı (kuyruk, outbox, e-belge, ajan, veritabanı)",
    "platform.transfers.manage": "İstasyon devri isteme, yürütme, iptal",
    "platform.exports.manage": "Kiracı verisi dışa aktarımı",
    "platform.closures.manage": "Kiracı kapanışı ve saklama sonrası anonimleştirme",
    "platform.announcements.manage": "Duyuru ve sürüm notu yayımlama",
    "platform.staff.manage": "Platform personeli ve rolleri",
    "platform.settings.manage": "Platform ayarları (faturalama kiracısı, gecikme süreleri, saklama süresi)",
};
export const PLATFORM_PERMISSION_KEYS = Object.keys(PLATFORM_PERMISSIONS);
export const platformPermissionSchema = z.enum(PLATFORM_PERMISSION_KEYS);
const READS = [
    "platform.tenants.read",
    "platform.catalog.read",
    "platform.billing.read",
    "platform.health.read",
];
export const PLATFORM_ROLE_PERMISSIONS = {
    SUPER_ADMIN: PLATFORM_PERMISSION_KEYS,
    SUPPORT: [
        ...READS,
        "platform.support.access",
        "platform.transfers.manage",
        "platform.exports.manage",
        "platform.announcements.manage",
    ],
    FINANCE: [...READS, "platform.plans.manage", "platform.billing.manage"],
    READ_ONLY: READS,
};
/** Rolün izni var mı? Rolü olmayan (platform personeli değil) kullanıcı hiçbir platform iznine sahip değildir. */
export function platformRoleHas(role, permission) {
    return role ? PLATFORM_ROLE_PERMISSIONS[role].includes(permission) : false;
}
export function platformPermissionsOf(role) {
    return role ? [...PLATFORM_ROLE_PERMISSIONS[role]] : [];
}
//# sourceMappingURL=roles.js.map